function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluebarchart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 71,
    viewBox: "0 0 72 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.757812,
    width: 70.7174,
    height: 70.7174,
    rx: 12.1927,
    fill: "#61CBDB",
    style: {
      fill: "#61CBDB",
      fill: "color(display-p3 0.3804 0.7961 0.8588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1172 37.7324C22.1172 36.6974 22.9572 35.8574 23.9922 35.8574H27.7422C28.7772 35.8574 29.6172 36.6974 29.6172 37.7324V48.9824C29.6172 50.0174 28.7772 50.8574 27.7422 50.8574H23.9922C23.4949 50.8574 23.018 50.6599 22.6664 50.3082C22.3147 49.9566 22.1172 49.4797 22.1172 48.9824V37.7324ZM33.3672 30.2324C33.3672 29.1974 34.2072 28.3574 35.2422 28.3574H38.9922C40.0272 28.3574 40.8672 29.1974 40.8672 30.2324V48.9824C40.8672 50.0174 40.0272 50.8574 38.9922 50.8574H35.2422C34.7449 50.8574 34.268 50.6599 33.9164 50.3082C33.5647 49.9566 33.3672 49.4797 33.3672 48.9824V30.2324ZM44.6172 22.7324C44.6172 21.6974 45.4572 20.8574 46.4922 20.8574H50.2422C51.2772 20.8574 52.1172 21.6974 52.1172 22.7324V48.9824C52.1172 50.0174 51.2772 50.8574 50.2422 50.8574H46.4922C45.9949 50.8574 45.518 50.6599 45.1664 50.3082C44.8147 49.9566 44.6172 49.4797 44.6172 48.9824V22.7324Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluebarchart);
export default __webpack_public_path__ + "static/media/bluebarchart.b63c03822314b7e5092aebd796c85d4d.svg";
export { ForwardRef as ReactComponent };